var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#EBB02D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3939_213646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.83398 7.99999C3.83398 8.54717 3.94176 9.08899 4.15115 9.59451C4.36055 10.1 4.66746 10.5594 5.05437 10.9463C5.44128 11.3332 5.90061 11.6401 6.40614 11.8495C6.91166 12.0589 7.45348 12.1667 8.00065 12.1667C8.54783 12.1667 9.08964 12.0589 9.59517 11.8495C10.1007 11.6401 10.56 11.3332 10.9469 10.9463C11.3338 10.5594 11.6408 10.1 11.8501 9.59451C12.0595 9.08899 12.1673 8.54717 12.1673 7.99999C12.1673 6.89493 11.7283 5.83512 10.9469 5.05372C10.1655 4.27232 9.10572 3.83333 8.00065 3.83333C6.89558 3.83333 5.83577 4.27232 5.05437 5.05372C4.27297 5.83512 3.83398 6.89493 3.83398 7.99999Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.68518V8L9.38889 9.38888",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3939_213646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.914bb4e8347e4f106f5e4280e84a6a1d.svg";
export { ForwardRef as ReactComponent };